import React, { useEffect, useState } from "react";
import { Form, Drawer, notification } from "../../components/Elements/appUtils";
import axios from "axios";
import { GetEachFormFields } from "../../components/_utils/formUtils";
import { getToken } from "../../request";
import { updateMainCategoryUrl } from "./api";

function EditMainCategory(props) {
    const { visible, editData, mainMenus, onClose, reloadTable, form } = props;

    const [mainCategoryFile, setMainCategoryFile] = useState("");
    const [mainCategoryBanner, setMainCategoryBanner] = useState("");
    const [fileReset, setFileReset] = useState(0);

    useEffect(() => {
        if (visible && editData?._id) {
            form.setFieldsValue({
                mainMenuId: editData?.mainMenuId?._id || undefined,
                mainCategoryName: editData?.mainCategoryName || "",
                mainCategoryDescription: editData?.mainCategoryDescription || "",
            });

            setMainCategoryFile("");
            setMainCategoryBanner("");
            setFileReset((prev) => prev + 1);
        }
    }, [visible, editData?._id]);

    const handleFileChange = (e) => {
        const file = e.files[0];
        setMainCategoryFile(file);
    };

    const handleBannerChange = (e) => {
        const file = e.files[0];
        setMainCategoryBanner(file);
    };

    const resetAndClose = () => {
        form.resetFields();
        setMainCategoryFile("");
        setMainCategoryBanner("");
        setFileReset((prev) => prev + 1);
        onClose();
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        if (!editData?._id) {
            notification.error({
                message: "Edit data not found",
            });
            return;
        }

        form.validateFields(async (err, valData) => {
            if (err) return;

            console.log("EDIT DRAWER VALUES =>", valData);

            try {
                const fd = new FormData();
                fd.append("obj", JSON.stringify(valData));

                if (mainCategoryFile && mainCategoryFile.name) {
                    fd.append("mainCategoryFile", mainCategoryFile);
                }

                if (mainCategoryBanner && mainCategoryBanner.name) {
                    fd.append("mainCategoryBanner", mainCategoryBanner);
                }

                const response = await axios.put(
                    updateMainCategoryUrl(editData._id),
                    fd,
                    getToken()
                );

                if (response.data.success) {
                    notification.success({
                        message: response.data.message || "Updated successfully",
                    });

                    resetAndClose();
                    reloadTable();
                } else {
                    notification.error({
                        message: response.data.message || "Something went wrong",
                    });
                }
            } catch (error) {
                console.log("UPDATE ERROR =>", error);
                console.log("BACKEND RESPONSE =>", error?.response?.data);

                notification.error({
                    message: error?.response?.data?.message || "Request failed",
                });
            }
        });
    };

    const inputTypes = {
        fields: [
            {
                key: "mainMenuId",
                label: "Main Menu",
                span: "col-md-12",
                type: "select",
                options: mainMenus,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => x.mainMenuName,
                onChange: (value) => {
                    form.setFieldsValue({
                        mainMenuId: value,
                    });
                },
            },
            {
                key: "mainCategoryName",
                label: "Main Category Name",
                span: "col-md-12",
                type: "text",
            },
            {
                key: "mainCategoryDescription",
                label: "Description",
                span: "col-md-12",
                type: "textarea",
            },
            {
                key: "mainCategoryFile",
                label: "Main Category File",
                span: "col-md-12",
                type: "file",
                fileName: mainCategoryFile,
                onChange: ({ target }) => {
                    handleFileChange(target);
                },
            },
            {
                key: "mainCategoryBanner",
                label: "Main Category Banner",
                span: "col-md-12",
                type: "file",
                fileName: mainCategoryBanner,
                onChange: ({ target }) => {
                    handleBannerChange(target);
                },
            },
        ],
    };

    return (
        <Drawer
            title="Edit Main Category"
            placement="right"
            width={"50%"}
            visible={visible}
            onClose={resetAndClose}
            destroyOnClose
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    minHeight: "100%",
                }}
            >
                <Form onSubmit={handleUpdate}>
                    <div className="row">
                        {inputTypes.fields.map((item, index) => {
                            let renderKey = item.key || index;

                            if (item.key === "mainCategoryFile") {
                                renderKey = `edit-mainCategoryFile-${fileReset}`;
                            }

                            if (item.key === "mainCategoryBanner") {
                                renderKey = `edit-mainCategoryBanner-${fileReset}`;
                            }

                            return (
                                <div className={item.span} key={renderKey}>
                                    <GetEachFormFields {...form} item={item} />
                                </div>
                            );
                        })}
                    </div>

                    <button className="btn btn-success">UPDATE</button>

                    <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={resetAndClose}
                    >
                        Cancel
                    </button>
                </Form>
            </div>
        </Drawer>
    );
}

export default Form.create()(EditMainCategory);
